cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    var PM_pmc_assemblebuying_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            let action = viewmodel.getParams().action;

            const displayForbidden = (viewmodel) => {
                if (viewmodel.getParams().mode === 'edit' && nowDates >= viewmodel.get("startTime").getValue() && nowDates <= viewmodel.get("endTime").getValue()
                    && viewmodel.get("status").getValue() == "1") {
                    viewmodel.setDisabled(true);
                    viewmodel.get("endTime").setDisabled(false);
                    viewmodel.get("iSimulate").setDisabled(false);
                    viewmodel.get("cDescription").setReadOnly(true);
                    viewmodel.get("labelImageUrl").setReadOnly(true);
                    viewmodel.get("btnAddRow").setVisible(false);
                    viewmodel.get("btnBatchOp").setVisible(false);
                    let gridModel = viewmodel.getGridModel();
                    let rows = viewmodel.get("assemblebuyingdetail").getRows();
                    let actions = gridModel.getCache('actions');
                    let actionsStates = [];
                    rows.forEach(data => {
                        let actionState = {};
                        actions.forEach(action => {
                            if (action.cItemName == "btnDeleteRow") {
                                actionState[action.cItemName] = {visible: false};
                            }
                        });

                        actionsStates.push(actionState);
                    });
                    gridModel.setActionsState(actionsStates);
                    let forbiddenColumns = ["productName", "price", "assembleNumbers", "singleLimitQuantity", "initialSales"];
                    let columStates = [];
                    let columns = viewmodel.get("assemblebuyingdetail").getColumns();
                    for (let column in columns) {
                        if (forbiddenColumns.indexOf(column) > -1) {
                            gridModel.setColumnState(column, 'bCanModify', false);
                        }
                    }
                } else if (viewmodel.getParams().mode === 'browse' && nowDates >= viewmodel.get("startTime").getValue() && nowDates <= viewmodel.get("endTime").getValue()
                    && viewmodel.get("status").getValue() == "1") {
                    viewmodel.get("btnEdit").setVisible(false);
                }
            }

            const displayiAreaId = (viewmodel) => {
                delPro();
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    // viewmodel.get('btnBatchOp').setVisible(true);
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }
            const delPro = () => {
                if (viewmodel.get('assemblebuyingdetail').getData() && viewmodel.get('assemblebuyingdetail').getData().length > 0) {
                    let pricenums = viewmodel.get('assemblebuyingdetail').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('assemblebuyingdetail').deleteRows(i);
                    }
                }
            }
            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                delPro();
            });
            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            })

            viewmodel.get("assemblebuyingdetail").on("beforeBrowse", function (data) {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                common.productReferBrowseSimple(viewmodel, data, null, "assemblebuyingdetail", null, areaId);
                return true;
            });


            viewmodel.on('afterLoadData', function (data) {
                displayForbidden(viewmodel);
                common.displayArea(viewmodel);

                if (viewmodel.get('labelImage').getValue() !== '' && viewmodel.get('labelImage').getValue() !== undefined) {
                    viewmodel.get('iTag').setValue(1);
                    viewmodel.get("labelImageUrl").setVisible(false);
                } else {
                    viewmodel.get('iTag').setValue(0);
                    viewmodel.get("labelImage").setVisible(false);
                }

                viewmodel.get('iTag').on('afterValueChange', function (data) {
                    if (data.value.value === '0') {
                        viewmodel.get("labelImageUrl").setVisible(true);
                        viewmodel.get("labelImage").setVisible(false);
                    } else {
                        viewmodel.get("labelImageUrl").setVisible(false);
                        viewmodel.get("labelImage").setVisible(true);
                    }
                });
                viewmodel.get('terminalType').setDisabled(true);
                viewmodel.get('assemblebuyingdetail').getEditRowModel().get('totalLimitQuantity').setState('min', 0);
                viewmodel.get('assemblebuyingdetail').getEditRowModel().get('singleLimitQuantity').setState('min', 0);
                viewmodel.get('assemblebuyingdetail').getEditRowModel().get('initialSales').setState('min', 0);
                viewmodel.get('assemblebuyingdetail').getEditRowModel().get('assembleNumbers').setState('min', 0);
                viewmodel.get('assemblebuyingdetail').getEditRowModel().get('price').setState('min', 0);

            });
            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'sProductCode' || item.fieldName === 'price') {
                        item.bCanModify = false;
                    } else if (item.fieldName === 'productPicUrl') {
                        item.bCanFilter = false;
                    } else if (item.fieldName === 'totalLimitQuantity' || item.fieldName === 'singleLimitQuantity') {
                        item.bCanFilter = true;
                        item.bCanModify = false;
                    } else if (item.fieldName === 'initialSales') {
                        item.bCanFilter = true;
                    }
                })
            })
            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('assemblebuyingdetail').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("assemblebuyingdetail").deleteRows(rowIndexes);
            })


            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {


                var obj = JSON.parse(data.data.data);


                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.memberPayType = setCheckBoxEnum(obj.memberPayType);

                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    }
                }

                // if (mode == 'add') {
                // 	if (viewmodel.get('startTime').getValue() <= nowDates) {
                // 		cb.utils.alert('开始时间大于当前时间', 'warning');
                // 		return false;
                // 	}
                // }

                if (viewmodel.get('startTime').getValue() >= viewmodel.get('endTime').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
                if (viewmodel.get('assemblebuyingdetail').getRows() == '') {
                    cb.utils.alert('所选商品不能为空', 'warning');
                    return false;
                } else {
                    for (let j = 0; j < viewmodel.get('assemblebuyingdetail').getRowsCount(); j++) {
                      if (!viewmodel.get('assemblebuyingdetail').getRows()[j].productId) {
                        cb.utils.alert('第' + (j + 1) + '行请选择相应的商品信息', 'warning');
                        return false;
                      }
                        if (viewmodel.get('assemblebuyingdetail').getCellValue(j, 'price') <= 0) {
                            cb.utils.alert('第' + (j + 1) + '行 拼团价格 必须大于0', 'warning');
                            return false;
                        }

                        if (viewmodel.get('assemblebuyingdetail').getCellValue(j, 'assembleNumbers') <= 0) {
                            cb.utils.alert('第' + (j + 1) + '行 成团人数 必须大于0', 'warning');
                            return false;
                        }
                    }
                    if (obj.assemblebuyingdetail) {
                        for (let i = 0; i < obj.assemblebuyingdetail.length; i++) {
                            let detail = obj.assemblebuyingdetail[i];
                            if (action == 'copy') {
                                detail.success = 0;
                                detail.peopleNumber = 0;
                                detail.purchasedProductQuantity = 0;
                            } else {
                                if (!detail.purchasedProductQuantity) {
                                    detail.purchasedProductQuantity = 0;
                                }
                                if (!detail.peopleNumber) {
                                    detail.peopleNumber = 0;
                                }
                                if (!detail.singleLimitQuantity) {
                                    detail.singleLimitQuantity = 0;
                                }
                                if (!detail.totalLimitQuantity) {
                                    detail.totalLimitQuantity = 0;
                                }
                            }
                        }
                    }
                }


                if (viewmodel.get('labelImageUrl').getValue() == 1) {
                    obj.labelImageUrl = "/pintuan1.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 2) {
                    obj.labelImageUrl = "/pintuan5.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 3) {
                    obj.labelImageUrl = "/pintuan4.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 4) {
                    obj.labelImageUrl = "/pintuan2.png";
                } else if (viewmodel.get('labelImageUrl').getValue() == 5) {
                    obj.labelImageUrl = "/tuangou3.png";
                }
                if (viewmodel.get('iTag').getValue() == 0) {
                    obj.labelImage = '';
                } else {
                    if (viewmodel.get('labelImage').getValue == '') {
                        cb.utils.alert('自定义标签未上传', 'warning');
                        return false;
                    } else {
                        obj.labelImageUrl = obj.labelImage;
                    }
                }


                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_assemblebuying_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_assemblebuying_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_assemblebuying_VM.Extend.js